export const SITE_URL = "https://theaidept.net";
export const SITE_NAME = "The AI Dept.";
export const DEFAULT_OG = "/theaidept-og.jpg";
export const DEFAULT_DESCRIPTION =
  "The AI Dept. installs and runs a managed team of AI agents plus real experts for your marketing, sales, and operations. Live in 30 days. Book a free AI audit.";

// Per-route title + meta description. Titles get the " | The AI Dept." suffix
// automatically (except the homepage). Keep descriptions ~150–160 chars.
export const SEO_MAP = {
  "/": {
    title: "Your AI Department — Marketing, Sales & Operations, Run for You",
    description: DEFAULT_DESCRIPTION,
    suffix: false,
  },
  "/workflow": {
    title: "AI Workflow Automation for Your Back Office",
    description:
      "Install AI agents that run the repetitive back-office work — scheduling, follow-up, data, and tool integrations — with a human accountable for every output.",
  },
  "/growth": {
    title: "AI Marketing & Creative Team, Managed for You",
    description:
      "A managed AI marketing and creative team: content, campaigns, and agents that turn attention into customers. Strategy, production, and reporting handled for you.",
  },
  "/product": {
    title: "Custom AI Product Engineering & Builds",
    description:
      "We scope, engineer, and ship custom AI products and internal tools — from idea to first customer — with a named human team accountable for the build.",
  },
  "/gallery": {
    title: "The Reel — AI Video Gallery",
    description:
      "Watch the reel: AI-produced ad creative, motion, and AI avatar / spokesperson video — directed by humans, produced at scale.",
  },
  "/growth/portfolio": {
    title: "The Reel — AI Video Gallery",
    description:
      "Watch the reel: AI-produced ad creative, motion, and AI avatar / spokesperson video — directed by humans, produced at scale.",
  },
  "/customers": {
    title: "Customer Work & Case Studies",
    description:
      "See the AI department in action across real estate, healthcare, legal, automotive, and home services — real work, real outcomes.",
  },
  "/work": {
    title: "Customer Work & Case Studies",
    description:
      "See the AI department in action across real estate, healthcare, legal, automotive, and home services — real work, real outcomes.",
  },
  "/pricing": {
    title: "AI Department Pricing — Plans From $500/mo",
    description:
      "Simple, flat monthly pricing for a managed AI department. Pick your team — marketing & creative or workflow & automation. Plans from $500/mo. Cancel anytime.",
  },
  "/audit": {
    title: "Free AI Readiness Audit — Six Scores, Not a Pitch",
    description:
      "Take the free Business DNA audit. Answer eight questions and get a readiness score plus a clear recommendation for where AI moves the needle first.",
  },
  "/labs": {
    title: "Labs — AI Plays, Playbooks & Field Notes",
    description:
      "Practical AI plays and playbooks from The AI Dept. — how we automate marketing, sales, and operations for businesses across five industries.",
  },
  "/about": {
    title: "AI Consulting & AI Leadership — About The AI Dept.",
    description:
      "The AI Dept. is the calm, accountable operator in a hyped category: AI agents plus human experts, with a named person answering for every result.",
  },
  "/our-brands": {
    title: "Our Brands",
    description: "The family of brands and ventures built and run by The AI Dept.",
  },
  "/careers": {
    title: "Careers — Build the AI Department",
    description:
      "Join The AI Dept. We hire operators who direct AI agents and answer for the work. See open roles across AI Standards, growth, workflow, and product.",
  },
  "/contact": {
    title: "Contact The AI Dept.",
    description:
      "Talk to The AI Dept. about installing an AI department for your business, or request a custom scope for multi-location and heavy custom builds.",
  },
};

export const getSeo = (pathname) => {
  const entry = SEO_MAP[pathname];
  if (entry) return entry;
  return { title: SITE_NAME, description: DEFAULT_DESCRIPTION, suffix: false };
};

export const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/theaidept-logo.png`,
  description:
    "Managed AI department — AI agents plus human experts running marketing, sales, and operations for small and mid-market businesses.",
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "sales",
    url: `${SITE_URL}/contact`,
  },
};
